/* eslint-disable multiline-comment-style */
import Color from '@bubble-dev/fantasy-color';
import { createVersionedColor, createVersionedColorDeprecated } from './helpers'; // --- special utility color functions ---
// overlay color for dialogues

export var overlayDesktop = createVersionedColor(Color.of(0x34, 0x34, 0x34, 0.5));
export var transparent = createVersionedColor(Color.of(255, 255, 255, 0)); // --- deprecated color functions ---

var colorFunctionDeprecation = {
  removalDate: 'v5.0.0',
  useInstead: 'a color variable'
};
/**
 * used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var autofillBackground = createVersionedColorDeprecated('autofillBackground', colorFunctionDeprecation, Color.of(236, 245, 92, 0.1));
/**
 * used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var autofillBorder = createVersionedColorDeprecated('autofillBorder', colorFunctionDeprecation, new Color('#CFD74A'));
/**
 * only used in bubble-contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var black = createVersionedColorDeprecated('black', colorFunctionDeprecation, new Color('#17120F'), new Color('#FFFFFF'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var blackHovered = createVersionedColorDeprecated('blackHovered', colorFunctionDeprecation, new Color('#000000'), new Color('#FFFFFF'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var blackPressed = createVersionedColorDeprecated('blackPressed', colorFunctionDeprecation, new Color('#0C0706'), new Color('#FFFFFF'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var blackDisabled = createVersionedColorDeprecated('blackDisabled', colorFunctionDeprecation, new Color('#BBB8B5'), new Color('#5A5755'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var blackShadow = createVersionedColorDeprecated('blackShadow', colorFunctionDeprecation, Color.of(0, 0, 0, 0.15));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var black60 = createVersionedColorDeprecated('black60', colorFunctionDeprecation, Color.of(0x17, 0x12, 0x0F, 0.6));
/**
 * only used in InformationBlockLabelAltOverlay
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var blackOverlay = createVersionedColorDeprecated('blackOverlay', colorFunctionDeprecation, Color.of(0x34, 0x34, 0x34, 0.9), Color.of(255, 255, 255, 0.90));
/**
 * only used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var darkGray = createVersionedColorDeprecated('darkGray', colorFunctionDeprecation, new Color('#787471'), new Color('#969492'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var darkGrayHovered = createVersionedColorDeprecated('darkGrayHovered', colorFunctionDeprecation, new Color('#514E4B'), new Color('#726E6D'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var darkGrayPressed = createVersionedColorDeprecated('darkGrayPressed', colorFunctionDeprecation, new Color('#64605D'), new Color('#848180'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var datepicker = createVersionedColorDeprecated('datepicker', colorFunctionDeprecation, new Color('#00565D'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var datepickerHovered = createVersionedColorDeprecated('datepickerHovered', colorFunctionDeprecation, new Color('#005056'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var datepickerPressed = createVersionedColorDeprecated('datepickerPressed', colorFunctionDeprecation, new Color('#004A51'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var disabled = createVersionedColorDeprecated('disabled', colorFunctionDeprecation, new Color('#9C9C9B'));
/**
 * only used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var divider = createVersionedColorDeprecated('divider', colorFunctionDeprecation, new Color('#EAE7E4'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var dividerHovered = createVersionedColorDeprecated('dividerHovered', colorFunctionDeprecation, new Color('#E2DEDA'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var dividerPressed = createVersionedColorDeprecated('dividerPressed', colorFunctionDeprecation, new Color('#E6E2DF'));
/**
 * only used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var dividerStrong = createVersionedColorDeprecated('dividerStrong', colorFunctionDeprecation, new Color('#D1D0CE'));
/**
 * only used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var dividerStrongHovered = createVersionedColorDeprecated('dividerStrongHovered', colorFunctionDeprecation, new Color('#787471'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var dividerStrongPressed = createVersionedColorDeprecated('dividerStrongPressed', colorFunctionDeprecation, new Color('#ABA9A6'));
/**
 * only used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var error = createVersionedColorDeprecated('error', colorFunctionDeprecation, new Color('#FA4C3C'), new Color('#E01D0B'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var errorDividerAndIcon = createVersionedColorDeprecated('errorDividerAndIcon', colorFunctionDeprecation, new Color('#FC8064'));
/**
 * only used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var errorHovered = createVersionedColorDeprecated('errorHovered', colorFunctionDeprecation, new Color('#E64637'), new Color('#C2190A'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var errorPressed = createVersionedColorDeprecated('errorPressed', colorFunctionDeprecation, new Color('#D61200'), new Color('#D11B0A'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var errorBackgroundWithoutBorder = createVersionedColorDeprecated('errorBackgroundWithoutBorder', colorFunctionDeprecation, new Color('#FFD5CF'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var errorBackgroundRegular = createVersionedColorDeprecated('errorBackgroundRegular', colorFunctionDeprecation, new Color('#FFD5CF'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var errorBackgroundDark = createVersionedColorDeprecated('errorBackgroundDark', colorFunctionDeprecation, new Color('#FFCCC4'), new Color('#3B1B18'));
/**
 * only used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var errorBackground = createVersionedColorDeprecated('errorBackground', colorFunctionDeprecation, new Color('#FFF6F5'), new Color('#17120F'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var errorBackgroundHovered = createVersionedColorDeprecated('errorBackgroundHovered', colorFunctionDeprecation, new Color('#FCEDEB'), new Color('#17120F'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var errorBackgroundPressed = createVersionedColorDeprecated('errorBackgroundPressed', colorFunctionDeprecation, new Color('#FCF1F0'), new Color('#17120F'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var focus = createVersionedColorDeprecated('focus', colorFunctionDeprecation, Color.of(234, 231, 228, 0.7));
/**
 * used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var gray = createVersionedColorDeprecated('gray', colorFunctionDeprecation, new Color('#F0EEEA'), new Color('#333130'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var grayDark = createVersionedColorDeprecated('grayDark', colorFunctionDeprecation, new Color('#EAE7E4'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var grayHovered = createVersionedColorDeprecated('grayHovered', colorFunctionDeprecation, new Color('#EAE7E4'), new Color('#333130'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var grayPressed = createVersionedColorDeprecated('grayPressed', colorFunctionDeprecation, new Color('#E4E1DE'), new Color('#333130'));
/**
 * used in bubble-ui/support-grid*
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var gridLine = createVersionedColorDeprecated('gridLine', colorFunctionDeprecation, Color.of(0xff, 0x55, 0x00, 1));
/**
 * used in bubble-ui/support-grid*
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var gridLineSoft = createVersionedColorDeprecated('gridLineSoft', colorFunctionDeprecation, Color.of(0xff, 0x55, 0x00, 0.5));
/**
 * used in bubble-ui/support-grid*
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var gridLineInverted = createVersionedColorDeprecated('gridLineInverted', colorFunctionDeprecation, Color.of(0x0, 0xff, 0xff, 1));
/**
 * used in bubble-ui/support-grid*
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var gridLineInvertedSoft = createVersionedColorDeprecated('gridLineInvertedSoft', colorFunctionDeprecation, Color.of(0x0, 0xff, 0xff, 0.5));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var green = createVersionedColorDeprecated('green', colorFunctionDeprecation, new Color('#18A15C'), new Color('#07824F'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var guidelinesOverlay1 = createVersionedColorDeprecated('guidelinesOverlay1', colorFunctionDeprecation, Color.of(0xd7, 0xbb, 0xd4, 0.6));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var guidelinesOverlay2 = createVersionedColorDeprecated('guidelinesOverlay2', colorFunctionDeprecation, Color.of(0xa5, 0xc6, 0xdb, 0.4));
/**
 * no used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var guidelinesOverlay3 = createVersionedColorDeprecated('guidelinesOverlay3', colorFunctionDeprecation, Color.of(179, 173, 153, 0.5));
/**
 * used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var keyboardFocus = createVersionedColorDeprecated('keyboardFocus', colorFunctionDeprecation, Color.of(52, 52, 48, 0.07));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var keyboardFocusBackground = createVersionedColorDeprecated('keyboardFocusBackground', colorFunctionDeprecation, Color.of(52, 52, 48, 0.03));
/**
 * used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var keyboardFocusDarkBackground = createVersionedColorDeprecated('keyboardFocusDarkBackground', colorFunctionDeprecation, Color.of(0xff, 0xff, 0xff, 0.3));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var legalPrimaryLinkUnderline = createVersionedColorDeprecated('legalPrimaryLinkUnderline', colorFunctionDeprecation, Color.of(23, 18, 15, 0.4));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var legalPrimaryLinkUnderlineHovered = createVersionedColorDeprecated('legalPrimaryLinkUnderlineHovered', colorFunctionDeprecation, Color.of(0, 0, 0, 0.4));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var legalPrimaryLinkUnderlinePressed = createVersionedColorDeprecated('legalPrimaryLinkUnderlinePressed', colorFunctionDeprecation, Color.of(12, 7, 6, 0.4));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var legalSecondaryLinkUnderline = createVersionedColorDeprecated('legalSecondaryLinkUnderline', colorFunctionDeprecation, Color.of(120, 116, 113, 0.4));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var legalSecondaryLinkUnderlineHovered = createVersionedColorDeprecated('legalSecondaryLinkUnderlineHovered', colorFunctionDeprecation, Color.of(81, 78, 75, 0.4));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var legalSecondaryLinkUnderlinePressed = createVersionedColorDeprecated('legalSecondaryLinkUnderlinePressed', colorFunctionDeprecation, Color.of(100, 96, 93, 0.4));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var legalWhiteLinkUnderline = createVersionedColorDeprecated('legalWhiteLinkUnderline', colorFunctionDeprecation, Color.of(255, 255, 255, 0.6));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var legalWhiteLinkUnderlineHovered = createVersionedColorDeprecated('legalWhiteLinkUnderlineHovered', colorFunctionDeprecation, Color.of(255, 255, 255, 0.5));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var legalWhiteLinkUnderlinePressed = createVersionedColorDeprecated('legalWhiteLinkUnderlinePressed', colorFunctionDeprecation, Color.of(255, 255, 255, 0.4));
/**
 * used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var metadata = createVersionedColorDeprecated('metadata', colorFunctionDeprecation, new Color('#979493'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var metadataHovered = createVersionedColorDeprecated('metadataHovered', colorFunctionDeprecation, new Color('#726E6D'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var metadataPressed = createVersionedColorDeprecated('metadataPressed', colorFunctionDeprecation, new Color('#848180'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var pressedBackground = createVersionedColorDeprecated('pressedBackground', colorFunctionDeprecation, Color.of(52, 52, 48, 0.05));
/**
 * used in contrib & icon-colors
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var primary = createVersionedColorDeprecated('primary', colorFunctionDeprecation, new Color('#EB6F93'));
/**
 * used in contrib & icon-colors
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var primaryDisabled = createVersionedColorDeprecated('primaryDisabled', colorFunctionDeprecation, Color.of(235, 111, 147, 0.4)); // constants.Colors.PRIMARY with 40% opacity

/**
 * used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var primaryHovered = createVersionedColorDeprecated('primaryHovered', colorFunctionDeprecation, new Color('#E16A8E'));
/**
 * used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var primaryPressed = createVersionedColorDeprecated('primaryPressed', colorFunctionDeprecation, new Color('#D76589'));
/**
 * used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var realBlack = createVersionedColorDeprecated('realBlack', colorFunctionDeprecation, new Color('#000000'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var red = createVersionedColorDeprecated('red', colorFunctionDeprecation, new Color('#FF0000'));
/**
 * used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var secondary = createVersionedColorDeprecated('secondary', colorFunctionDeprecation, new Color('#487B94'), new Color('#51839C'));
/**
 * used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var secondaryDisabled = createVersionedColorDeprecated('secondaryDisabled', colorFunctionDeprecation, Color.of(0x48, 0x7B, 0x94, 0.4));
/**
 * used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var secondaryHovered = createVersionedColorDeprecated('secondaryHovered', colorFunctionDeprecation, new Color('#305F75'));
/**
 * used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var secondaryPressed = createVersionedColorDeprecated('secondaryPressed', colorFunctionDeprecation, new Color('#3C6D85'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var secondaryFocus = createVersionedColorDeprecated('secondaryFocus', colorFunctionDeprecation, Color.of(0x48, 0x7B, 0x94, 0.7));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var secondaryLinkUnderline = createVersionedColorDeprecated('secondaryLinkUnderline', colorFunctionDeprecation, Color.of(0x48, 0x7B, 0x94, 0.4));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var secondaryLinkUnderlineHovered = createVersionedColorDeprecated('secondaryLinkUnderlineHovered', colorFunctionDeprecation, Color.of(0x30, 0x5F, 0x75, 0.4));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var secondaryLinkUnderlinePressed = createVersionedColorDeprecated('secondaryLinkUnderlinePressed', colorFunctionDeprecation, Color.of(0x3C, 0x6D, 0x85, 0.4));
/**
 * used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var shadowColor = createVersionedColorDeprecated('shadowColor', colorFunctionDeprecation, Color.of(70, 70, 82, 0.3));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var success = createVersionedColorDeprecated('success', colorFunctionDeprecation, new Color('#82BC7E'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var successDividerAndIcon = createVersionedColorDeprecated('successDividerAndIcon', colorFunctionDeprecation, new Color('#82BC7E'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var successBackground = createVersionedColorDeprecated('successBackground', colorFunctionDeprecation, new Color('#D3F0D1'), new Color('#122B21'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var successHovered = createVersionedColorDeprecated('successHovered', colorFunctionDeprecation, new Color('#6DAD6F'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var successPressed = createVersionedColorDeprecated('successPressed', colorFunctionDeprecation, new Color('#589E60'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var successBackgroundRegular = createVersionedColorDeprecated('successBackgroundRegular', colorFunctionDeprecation, new Color('#D3F0D1'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var successBackgroundDark = createVersionedColorDeprecated('successBackgroundDark', colorFunctionDeprecation, new Color('#C8EBC5'), new Color('#122B21'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var tertiary = createVersionedColorDeprecated('tertiary', colorFunctionDeprecation, new Color('#6C8992'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var textBlack = createVersionedColorDeprecated('textBlack', colorFunctionDeprecation, new Color('#343434'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var textBlackDisabled = createVersionedColorDeprecated('textBlackDisabled', colorFunctionDeprecation, new Color('#9C9C9B'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var textError = createVersionedColorDeprecated('textError', colorFunctionDeprecation, new Color('#E01D0B'), new Color('#FA4C3C'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var textErrorHovered = createVersionedColorDeprecated('textErrorHovered', colorFunctionDeprecation, new Color('#C2190A'), new Color('#E64637'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var textErrorPressed = createVersionedColorDeprecated('textErrorPressed', colorFunctionDeprecation, new Color('#D11B0A'), new Color('#D61200'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var textPrimary = createVersionedColorDeprecated('textPrimary', colorFunctionDeprecation, new Color('#FA6E8C'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var textPrimaryDisabled = createVersionedColorDeprecated('textPrimaryDisabled', colorFunctionDeprecation, // constants.Colors.TEXT_PRIMARY with 50% opacity, done manually to avoid
// platform inconsistencies
Color.of(245, 183, 201, 1));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var textPrimaryHovered = createVersionedColorDeprecated('textPrimaryHovered', colorFunctionDeprecation, new Color('#E66987'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var textPrimaryPressed = createVersionedColorDeprecated('textPrimaryPressed', colorFunctionDeprecation, new Color('#DC6482'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var textSecondary = createVersionedColorDeprecated('textSecondary', colorFunctionDeprecation, new Color('#50A5C3'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var textSecondaryHovered = createVersionedColorDeprecated('textSecondaryHovered', colorFunctionDeprecation, new Color('#3C9BCD'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var textSecondaryPressed = createVersionedColorDeprecated('textSecondaryPressed', colorFunctionDeprecation, new Color('#3292C6'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var textSuccess = createVersionedColorDeprecated('textSuccess', colorFunctionDeprecation, new Color('#07824F'), new Color('#18A15C'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var textWarning = createVersionedColorDeprecated('textWarning', colorFunctionDeprecation, new Color('#A16800'), new Color('#C98300'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var textWhite = createVersionedColorDeprecated('textWhite', colorFunctionDeprecation, new Color('#FFFFFF'), new Color('#121111'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var textGray = createVersionedColorDeprecated('textGray', colorFunctionDeprecation, new Color('#767676'));
/**
 * used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var warning = createVersionedColorDeprecated('warning', colorFunctionDeprecation, new Color('#C98300'), new Color('#A16800'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var warningDividerAndIcon = createVersionedColorDeprecated('warningDividerAndIcon', colorFunctionDeprecation, new Color('#E2AC62'));
/**
 * used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var warningHovered = createVersionedColorDeprecated('warningHovered', colorFunctionDeprecation, new Color('#B57600'), new Color('#875700'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var warningPressed = createVersionedColorDeprecated('warningPressed', colorFunctionDeprecation, new Color('#BF7D00'), new Color('#946000'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var warningBackgroundWithoutBorder = createVersionedColorDeprecated('warningBackgroundWithoutBorder', colorFunctionDeprecation, new Color('#FFEDBD'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var warningBackgroundRegular = createVersionedColorDeprecated('warningBackgroundRegular', colorFunctionDeprecation, new Color('#FFEDBD'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var warningBackgroundDark = createVersionedColorDeprecated('warningBackgroundDark', colorFunctionDeprecation, new Color('#FFE9AB'), new Color('#35270D'));
/**
 * used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var warningBackground = createVersionedColorDeprecated('warningBackground', colorFunctionDeprecation, new Color('#FFFBF0'), new Color('#121111'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var warningBackgroundHovered = createVersionedColorDeprecated('warningBackgroundHovered', colorFunctionDeprecation, new Color('#FCF6E6'), new Color('#121111'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var warningBackgroundPressed = createVersionedColorDeprecated('warningBackgroundPressed', colorFunctionDeprecation, new Color('#FCF8EB'), new Color('#121111'));
/**
 * used in contrib
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var white = createVersionedColorDeprecated('white', colorFunctionDeprecation, new Color('#FFFFFF'), new Color('#121111'));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var whiteShadow = createVersionedColorDeprecated('whiteShadow', colorFunctionDeprecation, Color.of(255, 255, 255, 0.2) // constants.Colors.WHITE with 20% opacity
);
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var whiteOverlay = createVersionedColorDeprecated('whiteOverlay', colorFunctionDeprecation, Color.of(255, 255, 255, 0.95));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var whiteHovered = createVersionedColorDeprecated('whiteHovered', colorFunctionDeprecation, Color.of(255, 255, 255, 0.8));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var whitePressed = createVersionedColorDeprecated('whitePressed', colorFunctionDeprecation, Color.of(255, 255, 255, 0.9));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var whiteFocus = createVersionedColorDeprecated('whiteFocus', colorFunctionDeprecation, Color.of(255, 255, 255, 0.7));
/**
 * @deprecated - not used?
 */

export var whiteDisabled = createVersionedColorDeprecated('whiteDisabled', colorFunctionDeprecation, Color.of(255, 255, 255, 0.5));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var whiteBorderDisabled = createVersionedColorDeprecated('whiteBorderDisabled', colorFunctionDeprecation, Color.of(255, 255, 255, 0.4));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var whiteBorderLoading = createVersionedColorDeprecated('whiteBorderLoading', colorFunctionDeprecation, Color.of(255, 255, 255, 0.6));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var imageBackground = createVersionedColorDeprecated('imageBackground', colorFunctionDeprecation, Color.of(23, 18, 15, 0.08));
/**
 * not used?
 * @deprecated this is an old color function and this be removed with v5.0.0, please use a color variable instead
 */

export var pressedBackground2 = createVersionedColorDeprecated('pressedBackground2', colorFunctionDeprecation, Color.of(0xf2, 0xf2, 0xf1, 0.4));
//# sourceMappingURL=asFunctions.js.map